var map = {
	"./b_UBA@2x.png": "747c",
	"./b_VFDMFB@2x.png": "8c13",
	"./b_ZenithBank@2x.png": "a78d",
	"./b_accessbank@2x.png": "ab8e",
	"./b_accessdiamondbank@2x.png": "bb1e",
	"./b_airteltigo@2x.png": "357c",
	"./b_alatbywema@2x.png": "9fa9",
	"./b_default@2x.png": "29e3",
	"./b_ecobanknigeriaplc@2x.png": "bf2f",
	"./b_fcmb@2x.png": "1f96",
	"./b_fidelitybank@2x.png": "97ea",
	"./b_firstbankofnigeria@2x.png": "7a0e",
	"./b_gtbank@2x.png": "3551",
	"./b_heritagebanking@2x.png": "0ff8",
	"./b_keystonebank@2x.png": "758f",
	"./b_kudamfb@2x.png": "1057",
	"./b_mtn@2x.png": "56c2",
	"./b_opaybank@2x.png": "8f42",
	"./b_paga@2x.png": "a06c",
	"./b_palmpay@2x.png": "8af8",
	"./b_polarisbankplc@2x.png": "acd1",
	"./b_providusbankplc@2x.png": "0929",
	"./b_stanbic_ibtcbankplc@2x.png": "0a5d",
	"./b_sterlingbank@2x.png": "ba00",
	"./b_unionbankofnigeria@2x.png": "67cd",
	"./b_unitybankplc@2x.png": "2809",
	"./b_vodafone@2x.png": "92b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ff5";